import React from 'react';

import { InfoCard } from '@eika/card';
import { Link, LinkType } from '@eika/link';

import { Content } from '../../components/shared/Content';
import { useConfig } from '../../defaultConfig';
import useTranslation from '../../hooks/useTranslation';
import SalaryInfoImg from './components/SalaryInfoImg';

import './EditSalaryInfoStartPage.scss';

const EditSalaryInfoStartPage: React.FC = () => {
    const translated = useTranslation();
    const { editSalaryInfoLink } = useConfig();
    return (
        <Content className="edit-salary-info-start-page">
            <InfoCard skipBackground>
                <SalaryInfoImg />
                <p>{translated.salaryInfo.editSalaryInfoStartPageDescription}</p>
            </InfoCard>
            {editSalaryInfoLink && (
                <Link linkType={LinkType.BUTTON_STANDARD_POSITIVE} href={editSalaryInfoLink.url}>
                    {translated.next}
                </Link>
            )}
        </Content>
    );
};

export default EditSalaryInfoStartPage;
